import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 h3 text-uppercase fw-bold" }, " Historial de beneficios utilizados ", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = {
  key: 0,
  class: "spinner-border text-success",
  role: "status"
}
const _hoisted_6 = { class: "row py-4" }
const _hoisted_7 = { class: "col col-lg-8 text-uppercase fw-bold" }
const _hoisted_8 = { class: "col col-lg-4 text-end" }

import { onMounted, ref } from 'vue'
import useSitio from '@/composables/useSitio'
import sleep from '@/utils/Sleep'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheBeneficiosRedimidos',
  setup(__props) {

const { getMisBeneficios } = useSitio()
const isLoading = ref(true)

const beneficios = ref<
  {
    fecha: string
    actividad: string
    codigo: string
  }[]
>([])

onMounted(async () => {
  isLoading.value = true
  await sleep(1)
  const data = await getMisBeneficios()
  beneficios.value = data
  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(beneficios.value, (beneficio, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-12"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(beneficio.actividad), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(beneficio.fecha), 1)
                ])
              ]))
            }), 128))
      ])
    ])
  ]))
}
}

})